<link
rel="stylesheet"
href="https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/css/flag-icons.min.css"
/>

<div class="flex justify-center">
  <h2 class="font-light leading-relaxed text-2xl my-8 text-gray-800 cursor-default" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Click on a city to see its Evaluation content</h2>
</div>

<div class="grid grid-cols-4">
        <ng-container *ngFor="let city of cities">
            <button id=btn class="w-1/2 rounded-lg my-8 px-1 py-2 font-bold cursor-pointer bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
            (click)="onCity(city)">
            <div class="flex justify-center">
              <div class="flex flex-col justify-center items-center">
                <div class="text text-center text-xl">
                  {{city.City}}
                </div>
                <div class="text text-center">
                  {{city.Country}}
                </div>
              </div>
              <span class="text fi fi-{{city.Code}} text-sm ml-4"></span>
            </div>
            </button>
        </ng-container>
</div>
<div class="flex justify-center">
  <button style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;"
    class="mt-8 px-8 py-2 text-2xl font-light cursor-pointer bg-headerfr hover:bg-buttonhover text-yellow-200 hover:text-colortext place-self-center"
    (click)="goToActions()">
    <div class="text-center justify-center">
      <i class="fas fa-running text-2xl"></i> <br> City Innovation Actions 
    </div>
  </button>
</div>